import { object, array } from "yup";

export const createTeamsValidationSchema = object().shape({
  teams: object().shape({
    pool: array().max(0),
  }),
});
